export enum DocumentStatus {
  new = 1,
  in_progress,
  finished,
  draft,
  published,
  archived,
  deleted,
}

export enum BuiltInStatus {
  new = 1,
  in_progress,
  finished,
  draft,
  published,
  archived,
  deleted,
  select
}

export enum TemplateStatus {
  draft = 4,
  published,
  archived,
  deleted,
}

export enum ReportStatus {
  new = 1,
  in_progress,
  finished,
}

export interface JobDataModel {
  clientId: string
  siteId: string

  createdBy: string
  updatedBy: string

  createdAt: Date | number
  createdAtRelative?: string
  updatedAt: Date | number
  updatedAtRelative?: string
}

export interface JobDataApiModel {
  client_id: string
  site_id: string

  created_by: string
  updated_by: string

  created_at: Date | number
  updated_at: Date | number
}

export interface StatusRawModel {
  id?: number
  builtIn: boolean
  name: string
  textColor: string
  bgColor: string
  iconName: string
  iconColor: string
}

export interface StatusModel extends StatusRawModel, JobDataModel {}